import classNames from 'classnames';
import React from 'react';
import Text from '../Text';
import StepBadge from './StepBadge';
import { UpgradeStepStatus } from './types';

interface Props {
  label: string;
  status: UpgradeStepStatus;
  number: number;
  progress?: number;
  durationLabel?: string;
}

const statusLabels = { completed: 'Completed', active: 'In progress', pending: 'Not started' };

export default function UpgradeProgressStep({ label, status, number, progress, durationLabel }: Props) {
  return (
    <li
      aria-current={status === 'active' ? 'step' : undefined}
      className={classNames(
        'flex min-h-24 items-center gap-4 rounded-lg p-6',
        status === 'active' ? 'bg-selected-faint' : 'bg-sub',
      )}
    >
      <StepBadge status={status} number={number} />
      <div className="min-w-0 flex-1 space-y-3">
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
          <Text
            as="p"
            variant={status === 'pending' ? 'muted' : 'base'}
            className="min-w-0 text-lg font-medium"
          >
            {label}
            <Text variant="base" className="sr-only">
              : {statusLabels[status]}
            </Text>
          </Text>
          {durationLabel && (
            <Text variant="muted" className="shrink-0 whitespace-nowrap">
              {durationLabel}
            </Text>
          )}
        </div>
        {status === 'active' && progress !== undefined && (
          <div
            className="h-1.5 w-full overflow-hidden rounded bg-control-primary/25"
            role="progressbar"
            aria-label={label}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.floor(progress * 100)}
          >
            <div
              className="h-full rounded bg-control-primary transition-[width] duration-200 ease-linear motion-reduce:transition-none"
              style={{ width: `${progress * 100}%` }}
            />
          </div>
        )}
      </div>
    </li>
  );
}
